/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SyncResult {
    ACTIVE_ENTITLEMENT = 'ACTIVE_ENTITLEMENT',
    NO_ACTIVE_ENTITLEMENT = 'NO_ACTIVE_ENTITLEMENT',
    SYNC_FAILED = 'SYNC_FAILED',
}
